import type { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import Dialog, { Clip, Close } from '../../components/molecules/Dialog';
import DialogHeader from '../../components/molecules/DialogHeader';
import Label from '../atoms/Label';
import VolumeControl from '../molecules/VolumeControl';

const List = styled.div`
	bottom: 10%;
	display: flex;
	flex-flow: column nowrap;
	justify-content: space-evenly;
	left: 5%;
	position: absolute;
	right: 5%;
	top: 40%;
`;

const Item = styled.div`
	align-items: center;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	${Label} {
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export interface StateProps {
	backgroundSoundEnabled: boolean;
	backgroundSoundVolume: number;
	soundEffectsEnabled: boolean;
	soundEffectsVolume: number;
}

export interface DispatchProps {
	setBackgroundSoundEnabled: (enabled: boolean) => void;
	setBackgroundSoundVolume: (volume: number) => void;
	setSoundEffectsEnabled: (enabled: boolean) => void;
	setSoundEffectsVolume: (volume: number) => void;
}

export interface OwnProps {
	onClose: () => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const SettingsDialog: FunctionComponent<Props> = (props: Props) => {
	const {
		backgroundSoundEnabled,
		backgroundSoundVolume,
		setBackgroundSoundEnabled,
		setBackgroundSoundVolume,
		soundEffectsEnabled,
		soundEffectsVolume,
		setSoundEffectsEnabled,
		setSoundEffectsVolume,
		onClose
	} = props;

	return (
		<Dialog small closeButton={<Close onClose={onClose} />}>
			<Clip>
				<DialogHeader>
					<Trans>settings.title</Trans>
				</DialogHeader>
				<List>
					<Item>
						<Label bold light>
							<Trans>settings.background_sound</Trans>
						</Label>
						<VolumeControl
							width="70%"
							enabled={backgroundSoundEnabled}
							onSoundEnabled={setBackgroundSoundEnabled}
							volume={backgroundSoundVolume}
							onVolumeChanged={setBackgroundSoundVolume}
						/>
					</Item>
					<Item>
						<Label bold light>
							<Trans>settings.sound_effects</Trans>
						</Label>
						<VolumeControl
							width="70%"
							enabled={soundEffectsEnabled}
							onSoundEnabled={setSoundEffectsEnabled}
							volume={soundEffectsVolume}
							onVolumeChanged={setSoundEffectsVolume}
						/>
					</Item>
				</List>
			</Clip>
		</Dialog>
	);
};

export default SettingsDialog;
